module.exports = __webpack_public_path__ + "static/sending_stones-745f05a4e1457a8babc161aa2d5f80b9.jpeg";